import React from 'react';

import './styles/instrument-details.scss';
import InstrumentDetailsItem from './InstrumentDetailsItem';
import OpenInstrumentDetailsTrackingEvent from '../analytics/OpenInstrumentDetailsTrackingEvent';

export type Props = {
  instrumentId: string;
  serialNumber: string;
  softwareVersion: string;
  mainFirmwareVersion: string;
  powerFirmwareVersion: string;
  lidFirmwareVersion: string;
  instrumentName: string;
  instrumentNameLine2?: string;
  apiVersion: string;
  imageVersion: string;
  displayModel: string;
  instrumentModel: string;
};

export default function InstrumentDetails({
  serialNumber,
  instrumentId,
  softwareVersion,
  mainFirmwareVersion,
  powerFirmwareVersion,
  lidFirmwareVersion,
  displayModel,
  apiVersion,
  instrumentName,
  instrumentNameLine2,
  imageVersion,
  instrumentModel
}: Props) {
  const openInstrumentDetailsTrackingEvent = new OpenInstrumentDetailsTrackingEvent();
  openInstrumentDetailsTrackingEvent.track(instrumentModel, instrumentId);

  return (
    <div className="conventional-pcr-details">
      <div className="run-details-panel" />
      <div className="instrument-details-panel">
        <div className="instrument-details-title-label">INSTRUMENT DETAILS</div>
        <div className="instrument-details-panel-body">
          <table className="general-instrument-details">
            <tbody>
              <InstrumentDetailsItem
                id={`sn_${instrumentId}`}
                value={serialNumber}
                label="Serial Number"
                valueClassName="general-instrument-details-value"
              />
              <InstrumentDetailsItem
                id={`instrument-details-model_${instrumentId}`}
                value={displayModel}
                label="Instrument Model"
                valueClassName="general-instrument-details-value"
              />
              <InstrumentDetailsItem
                id={`name_${instrumentId}`}
                value={instrumentName}
                label="Instrument Name"
                valueClassName="general-instrument-details-value"
              />
              {instrumentNameLine2 && (
                <InstrumentDetailsItem
                  id={`name-line-2_${instrumentId}`}
                  value={instrumentNameLine2}
                  label=""
                  valueClassName="general-instrument-details-value"
                />
              )}
            </tbody>
          </table>
          <table className="software-firmware-versions">
            <tbody>
              <InstrumentDetailsItem
                id={`software_${instrumentId}`}
                value={softwareVersion}
                label="Software"
              />
              <InstrumentDetailsItem
                id={`main-frmw_${instrumentId}`}
                value={mainFirmwareVersion}
                label="Main Firmware"
              />
              <InstrumentDetailsItem
                id={`power-frmw_${instrumentId}`}
                value={powerFirmwareVersion}
                label="Power Firmware"
              />
              <InstrumentDetailsItem
                id={`lid-frmw_${instrumentId}`}
                value={lidFirmwareVersion}
                label="Lid Firmware"
              />
              <InstrumentDetailsItem
                id={`api-ver_${instrumentId}`}
                value={apiVersion}
                label="API Version"
              />
              <InstrumentDetailsItem
                id={`image-ver_${instrumentId}`}
                value={imageVersion}
                label="Image Version"
              />
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
